module.exports = __webpack_public_path__ + "img/Belgium.1d636b06.svg";